import React from 'react';
interface LanguageSelectorProps {
  onSelect: (lang: string) => void;
}
const LANGUAGES = [{
  code: 'en',
  label: 'English',
  flag: '🇬🇧'
}, {
  code: 'no',
  label: 'Norsk',
  flag: '🇳🇴'
}, {
  code: 'sv',
  label: 'Svenska',
  flag: '🇸🇪'
}, {
  code: 'da',
  label: 'Dansk',
  flag: '🇩🇰'
}];
const SUBTITLES: Record<string, string> = {
  en: 'Select your language',
  no: 'Velg språk',
  sv: 'Välj språk',
  da: 'Vælg sprog'
};
export function LanguageSelector({
  onSelect
}: LanguageSelectorProps) {
  return <div className="flex flex-col h-full w-full justify-center items-center animate-fade-in-up" data-id="element-48">
      <div className="mb-10 text-center" data-id="element-49">
        <div className="text-solventum-primary text-sm font-body uppercase tracking-widest mb-6" data-id="element-50">
          Solventum
        </div>

        {/* Small globe / language indicator */}
        <div className="relative inline-flex items-center justify-center mb-6" data-id="element-51">
          <div className="absolute w-20 h-20 rounded-full bg-solventum-primary/10 animate-pulse" data-id="element-52" />
          <svg className="relative w-12 h-12 text-solventum-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} data-id="element-53">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A9.004 9.004 0 0121 12c0 .898-.132 1.765-.378 2.582M4.157 7.582A9.004 9.004 0 003 12c0 .898.132 1.765.378 2.582m0 0a8.997 8.997 0 007.843 4.582m-7.843-4.582A11.95 11.95 0 0112 13.5c2.998 0 5.74 1.1 7.843 2.918" data-id="element-54" />
          </svg>
        </div>

        <h1 className="text-xl md:text-2xl font-extrabold text-white mb-2 leading-tight" data-id="element-55">
          {SUBTITLES.en} / {SUBTITLES.no}
        </h1>
        <p className="text-white/50 font-body text-sm" data-id="element-56">
          {SUBTITLES.sv} · {SUBTITLES.da}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 w-full max-w-xs" data-id="element-57">
        {LANGUAGES.map(lang => <button key={lang.code} onClick={() => onSelect(lang.code)} className="flex flex-col items-center gap-2 bg-white/5 border-2 border-white/10 hover:border-solventum-primary rounded-2xl py-6 px-4 transition-all duration-300 hover:bg-white/10 group" data-id="element-58">
            <span className="text-4xl mb-1" data-id="element-59">{lang.flag}</span>
            <span className="text-white font-headline font-bold text-base group-hover:text-solventum-primary transition-colors" data-id="element-60">
              {lang.label}
            </span>
          </button>)}
      </div>
    </div>;
}